import qs, { parse, stringify } from 'query-string'
import { Dictionary } from '@feedyou/utils'
import { Location } from 'history'

export interface UrlParam {
  name: string
  value: string | boolean
}

export const getParams = (params?: UrlParam[]): string => {
  if (!params) {
    return ''
  }

  const paramsObject = params.reduce(
    (params, { name, value }) => ({ ...params, [name]: value }),
    {}
  )

  return `?${stringify(paramsObject)}`
}

export const searchParamsToObject = (
  search: string
): Dictionary<string, string | string[] | null> => {
  if (!search) {
    return {}
  }
  //@ts-ignore
  return parse(search)
}

export const getLoadedBotIdFromUrl = () => {
  const { pathname } = window.location
  if (!pathname.startsWith('/bots/')) {
    return null
  }

  const botId = pathname.split('/')[2]

  if (!botId) {
    return null
  }

  return botId
}

export const hasParam = (location: Location<unknown>, param: string): boolean => {
  // additional spread required - qs.parse() return is missing object methods
  return { ...qs.parse(location.search) }.hasOwnProperty(param)
}

export const modifyUrlQueryParams = (url: string, params: Dictionary<string, any>): string => {
  const parsed = qs.parseUrl(url)

  return qs.stringifyUrl({
    url: parsed.url,
    query: { ...parsed.query, ...params }
  })
}
